import media from "common/styles/media";

const theme = {
  color: {},
  ...media,
};

export default theme;
